import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  brandGuideAPI,
  CreateBrandGuideRequest,
  UpdateBrandGuideRequest,
} from "../api";

export const useGetBrandGuideItems = (search?: string) => {
  return useQuery({
    queryKey: ["brandGuideItems", search],
    queryFn: () => brandGuideAPI.getAllItems(search),
  });
};

export const useGetBrandGuideItemById = (id: string) => {
  return useQuery({
    queryKey: ["brandGuideItem", id],
    queryFn: () => brandGuideAPI.getItemById(id),
    enabled: !!id,
  });
};

export const useCreateBrandGuideItem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateBrandGuideRequest) =>
      brandGuideAPI.createItem(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["brandGuideItems"] });
    },
  });
};

export const useCreateBrandGuideItemWithFile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      data,
      file,
    }: {
      data: CreateBrandGuideRequest;
      file: File;
    }) => brandGuideAPI.createItemWithFile(data, file),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["brandGuideItems"] });
    },
  });
};

export const useUpdateBrandGuideItem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateBrandGuideRequest }) =>
      brandGuideAPI.updateItem(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["brandGuideItems"] });
    },
  });
};

export const useUpdateBrandGuideItemWithFile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      data,
      file,
    }: {
      id: string;
      data: UpdateBrandGuideRequest;
      file: File;
    }) => brandGuideAPI.updateItemWithFile(id, data, file),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["brandGuideItems"] });
    },
  });
};

export const useDeleteBrandGuideItem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => brandGuideAPI.deleteItem(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["brandGuideItems"] });
    },
  });
};
